import { useState, useRef } from "react";
import proyectos from "../../data/proyects.json";
import { useParams } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import Map from "../../components/Map";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/effect-fade";
import { EffectFade, Autoplay } from "swiper";

function ProyectView() {
  const { id } = useParams();
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const swiperRef = useRef(null); // Referencia para controlar Swiper

  const proyecto = proyectos.find((proyecto) => proyecto.id === Number(id));

  return (
    <section className="py-20 bg-white mt-32">
      <div className="flex flex-col px-8 mx-auto space-y-12 max-w-7xl xl:px-12">
        {/* Imagen principal */}
        <section
          className="flex flex-col w-full h-[500px] bg-cover bg-center justify-center items-center sm:bg-fixed"
          style={{ backgroundImage: `url(${proyecto.imagenes[0].imgUrl})` }}
        >
          <h2 className="text-white text-5xl font-semibold mt-20 mb-10">
            {proyecto.nombre}
          </h2>
        </section>

        {/* Swiper Slider */}
        {Array.isArray(proyecto.reales) && proyecto.reales.length > 0 && (
          <div>
            {/* Descripción breve del proyecto */}
            <section className="text-center mb-12">
              <p className="text-lg text-gray-700 max-w-3xl mx-auto">
                Este proyecto es una inversión única que ofrece un diseño
                moderno y funcional, pensado para ofrecer lo mejor en comodidad
                y estilo. ¡Descubre más sobre sus características a
                continuación!
              </p>
            </section>
            <Swiper
              modules={[EffectFade, Autoplay]}
              effect="fade"
              loop={true}
              autoplay={{ delay: 3000, disableOnInteraction: false }}
              className="h-[500px] lg:h-[600px]"
              onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
              onSwiper={(swiper) => (swiperRef.current = swiper)}
            >
              {proyecto.reales.map((imagen, index) => (
                <SwiperSlide
                  key={index}
                  className="relative flex justify-center items-center"
                >
                  <img
                    className="object-cover w-full h-full"
                    src={imagen.imgUrl}
                    alt=""
                  />
                </SwiperSlide>
              ))}
            </Swiper>

            {/* Miniaturas debajo del slider */}
            <div className="flex justify-center mt-4 space-x-2 overflow-y-auto">
              {proyecto.reales.map((imagen, index) => (
                <img
                  key={index}
                  src={imagen.imgUrl}
                  alt=""
                  className={`w-20 h-16 md:w-32 md:h-24 object-cover cursor-pointer rounded-md transition-all duration-300 my-2 ${
                    activeIndex === index
                      ? "border-4 border-primary scale-110"
                      : "opacity-70 hover:opacity-100"
                  }`}
                  onClick={() => {
                    swiperRef.current?.slideToLoop(index);
                    setActiveIndex(index);
                  }}
                />
              ))}
            </div>
          </div>
        )}

        {/* Imágenes individuales */}
        {proyecto.imagenes.map((imagen, index) => (
          <div key={index} className="flex flex-col mb-8 sm:flex-row">
            <div
              className={`flex items-center sm:w-1/2 md:w-5/12 ${
                index % 2 !== 0 ? "sm:order-last" : ""
              }`}
            >
              <img
                className="rounded-lg shadow-xl cursor-pointer w-full h-auto object-cover"
                src={imagen.imgUrl}
                alt=""
                onClick={() => setSelectedImage(imagen.imgUrl)}
              />
            </div>
            <div className="flex flex-col justify-center sm:w-1/2 md:w-7/12 sm:px-8">
              <h3 className="text-2xl md:text-4xl">{imagen.title}</h3>
              <p className="mt-5 text-lg text-gray-700">{imagen.descripcion}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Modal para ver la imagen ampliada */}
      {selectedImage && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 z-50"
          onClick={() => setSelectedImage(null)}
        >
          <div className="relative">
            <button
              className="absolute top-2 right-2 text-white bg-black p-2 rounded-full"
              onClick={() => setSelectedImage(null)}
            >
              X
            </button>
            <img
              className="max-w-5xl max-h-full object-contain"
              src={selectedImage}
              alt="Expanded View"
            />
          </div>
        </div>
      )}

      {/* Mapa */}
      <div className="flex items-center justify-center py-8 container mx-auto">
        <div className="bg-white w-full p-4 border-b">
          <h2 className="text-2xl">Ubicación</h2>
          <div className="mt-4">
            <Map src={proyecto.maps} />
          </div>
        </div>
      </div>

      {/* Contacto */}
      <div className="max-w-5xl mx-auto bg-gray-100 p-8 rounded-xl shadow-lg mt-16 text-center">
        <h3 className="text-2xl font-semibold text-gray-900">
          ¿Queres saber más sobre este proyecto?
        </h3>
        <p className="text-gray-600 mt-2">
          Contáctanos para brindarte más información y asesorarte en tu compra.
        </p>
        <a
          href={`https://api.whatsapp.com/send?phone=5492241460121&text=Hola%20Agustin,%20quisiera%20saber%20más%20información%20sobre%20el%20proyecto%20${proyecto.nombre},%20Gracias!`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex justify-center items-center mt-6 bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-lg text-lg shadow-md transition-all duration-300"
        >
          <FaWhatsapp className="mr-2" />
          Hablar por WhatsApp
        </a>
      </div>
    </section>
  );
}

export default ProyectView;
